exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__DateField__Wrapper,\n.DS__DateField__TextField {\n  all: initial;\n  font-family: var(--font-family);\n}\n\n.DS__DateField__Wrapper {\n  position: relative;\n  display: block;\n}\n\n.DS__DateField__TextField {\n  display: block;\n  max-width: 320px;\n}\n\n@media (max-width: 767px) {\n\n.DS__DateField__TextField {\n    max-width: inherit\n}\n  }\n\n.DS__DateField__TextField_block {\n    max-width: inherit;\n  }\n\n.DS__DateField__datepicker_component {\n  z-index: 100;\n}\n", ""]);

// exports
exports.locals = {
	"Wrapper": "DS__DateField__Wrapper",
	"TextField": "DS__DateField__TextField",
	"TextField_block": "DS__DateField__TextField_block",
	"datepicker_component": "DS__DateField__datepicker_component"
};